import { useAuthService } from '@b2ag/auth'
import { getAppContext, useCoreImports } from '@b2ag/micro-front-tools'
import { useUserData } from '@b2ag/user-data'
import { locationStorage } from '../services'
import { cleanForceLoginFromPath } from '../helpers/cleanForceLoginFromPath'
import { checkAndRedirectIfUserIsNotOnCorrectLocalizedRoute } from '@b2ag/utils/src/i18n-routing'
import type { RouteLocationNormalized, RouteLocationNormalizedLoaded, NavigationGuardNext } from 'vue-router'
const { isFrontAgri, isFrontTech } = getAppContext()

export async function routerBeforeEach(
  _context: { storeInstance: unknown },
  to: RouteLocationNormalized,
  from: RouteLocationNormalizedLoaded,
  next: NavigationGuardNext,
) {
  const userData = useUserData()

  if (import.meta.browser && !window.location.href.includes('oauth')) {
    checkAndRedirectIfUserIsNotOnCorrectLocalizedRoute(
      userData.currentProfile.value?.cooperative?.locales,
      useCoreImports().showError,
    )
  }

  if (to.meta.disabled) {
    return next({ name: 'not-found' })
  }

  if (!to.meta.doNotStoreRoute || to.meta.storePathBeforeAuth || to.query?.forceLogin) {
    locationStorage.storeLocation(cleanForceLoginFromPath(to.fullPath))
  }

  /* Dernière vérification avant d'entrée dans un état possiblement connecté : to.meta.oauthWorkflow */

  if (to.meta.oauthWorkflow) {
    return next()
  }

  /* À partir d'ici, on entre forcément dans un environnement connecté */
  const isAuthenticated = await useAuthService().isAuthenticated()

  if (isAuthenticated) {
    if (
      isFrontAgri &&
      !to.meta.inscriptionFlow &&
      !userData.hasConfirmedProfile.value &&
      to.name !== 'account-add-cooperative'
    ) {
      next({ name: 'account-add-cooperative' })
      return true
    }

    if (
      isFrontAgri &&
      !userData.hasCurrentProfile.value &&
      userData.hasConfirmedProfile.value &&
      !['current-profile', 'account-add-cooperative'].includes(String(to.name))
    ) {
      next({ name: 'current-profile' })
      return true
    }

    // Redirect to home if user has current profile but tries to access current-profile page
    if (isFrontAgri && userData.hasCurrentProfile.value && to.name === 'current-profile') {
      next({ path: '/' })
      return true
    }

    // CGU verification
    if (isFrontAgri && !userData.isCGUAccepted.value && to.name !== 'accept-cgu-agri') {
      return next({ name: 'accept-cgu-agri' })
    }
    if (isFrontTech && !userData.isCGUAccepted.value && to.name !== 'accept-cgu-tech') {
      return next({ name: 'accept-cgu-tech' })
    }
  }

  if (from.fullPath === to.fullPath) {
    // XJU : custom fix to prevent redirection in SPA mode after initial load
    return next(false)
  }

  return next()
}
